import { jsx as _jsx } from "react/jsx-runtime";
import { GalleryView } from "@air/component-gallery-view";
import { MouseSelectionContainer } from "~/components/MouseSelectionContainer";
import { useGallerySelectableItemsPositions } from "~/hooks/useGallerySelectableItemsPositions";
export const SelectableGalleryView = (param)=>{
    let { containerRef, sections, scrollElementRef, minSelectionTopPosition = 110, ...galleryViewProps } = param;
    const { itemsPositions } = useGallerySelectableItemsPositions({
        sections
    });
    return /*#__PURE__*/ _jsx(MouseSelectionContainer, {
        scrollElementRef: scrollElementRef,
        containerRef: containerRef,
        itemsPositions: itemsPositions,
        minSelectionTopPosition: minSelectionTopPosition,
        children: /*#__PURE__*/ _jsx(GalleryView, {
            scrollElementRef: scrollElementRef,
            sections: sections,
            ...galleryViewProps
        })
    });
};
